import { render, staticRenderFns } from "./GAuthTextUnderline.vue?vue&type=template&id=68a18be0&scoped=true&"
import script from "./GAuthTextUnderline.vue?vue&type=script&lang=ts&"
export * from "./GAuthTextUnderline.vue?vue&type=script&lang=ts&"
import style0 from "./GAuthTextUnderline.vue?vue&type=style&index=0&id=68a18be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a18be0",
  null
  
)

export default component.exports